/** Oyun dengesi sabitleri — magic number yok */
export const gameBalance = {
  previewDurationMs: 2500,
  gridSize: 12,
  gridColumns: 2,
  gridRows: 6,
  previewBanknoteWidth: 560,
  previewBanknoteHeight: 280,
  gridBanknoteWidth: 490,
  gridBanknoteHeight: 210,
  gridGapX: 32,
  gridGapY: 14,
} as const;
